module.exports = __webpack_public_path__ + "img/lan_tour_route_05.3c4d02be.jpg";